import { Stack } from 'expo-router';
import React from 'react';
import { Platform } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

export default function AuthLayout() {
  const stack = (
    <Stack>
      <Stack.Screen name="login" options={{ headerShown: false }} />
      <Stack.Screen name="register" options={{ headerShown: false }} />
      <Stack.Screen name="client-onboarding" options={{ headerShown: false }} />
      <Stack.Screen name="reset-password" options={{ headerShown: false }} />
    </Stack>
  );

  if (Platform.OS === 'web') {
    return stack;
  }

  return (
    <SafeAreaView className="flex-1 bg-card" edges={['top', 'bottom']}>
      {stack}
    </SafeAreaView>
  );
}
